import Icon from "@mui/icons-material/ReorderRounded";

export default function MethodBrowserIcon() {
	return <Icon fontSize="small" />;
}
